
$(function () {

	//AHW Sticky header
	var e = $(document).scrollTop();
	var t = $(".navbar").outerHeight();
	$(window).on('scroll',function () {
		var n = $(document).scrollTop();
		if ($(document).scrollTop() >= 0) {
			$(".navbar").css("position", "relative");
		}
		if ($(document).scrollTop() >= 10) {
			$(".navbar").css("position", "fixed");
		}
		if (n > t) {
			$(".navbar").addClass("scroll");
		} else {
			$(".navbar").removeClass("scroll");
		}
		if (n > e) {
			$(".navbar").removeClass("no-scroll");
		} else {
			$(".navbar").addClass("no-scroll");
		}
		e = $(document).scrollTop();

	});

	//Close menu
	$('.navbar-icon,.close-menu').on('click', function (e) {
		e.preventDefault();
		$('.header-menu').fadeToggle(300)
	})

	//AHW lazyload images
	$("img").unveil(300); // 300px before they appear on the screen


	//AHW scroll down
	$('.navbar').onePageNav({
		currentClass: 'current',
		changeHash: false,
		scrollSpeed: 750,
		scrollThreshold: 0.5,
		filter: '',
		easing: 'swing',
		begin: function() {
			//I get fired when the animation is starting
		},
		end: function() {
			//I get fired when the animation is ending
		},
		scrollChange: function($currentListItem) {
			//I get fired when you enter a section and I pass the list item of the section
		}
		
	});

});
